import { FC } from 'react';
import { Drawer } from 'vaul';
import { RootProps } from '../../types';

export const Layout: FC<RootProps> = (props) => (
  <Drawer.Root
    {...props}
    noBodyStyles
    shouldScaleBackground={false}
    setBackgroundColorOnScale={false}
  />
);
